import { toast } from "sonner";

export const notifyStockWarnings = (warnings) => {
  if (!warnings?.length) return;
  const list = warnings.map((w) => `${w.product_name} (${w.stock_qty})`).join(", ");
  toast.warning(`Stock short: ${list}`, { duration: 8000 });
};

export const stockTone = (p) => {
  const s = Number(p.stock_qty || 0);
  if (s <= 0) return "bg-[color:var(--primary)]/10 text-[color:var(--primary)]";
  if (s <= Number(p.low_stock_threshold ?? 10)) return "bg-[color:var(--mustard)]/20 text-[#9A742E]";
  return "bg-[color:var(--moss)]/10 text-[color:var(--moss)]";
};

export const fmtQty = (n) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(n || 0);
